import { accorder } from '../plural.js';
export const de = {
    langue: {
        selecteur: 'Sprache',
    },
    coquille: {
        sautContenu: 'Zum Inhalt springen',
        deconnexion: 'Abmelden',
        versionInconnue: 'unbekannt',
        version: (version, horodatage) => `Version ${version} — Build vom ${horodatage}`,
        signature: '— Repère, Organisation & Gelassenheit',
    },
    compte: {
        menu: 'Menü',
        monCompte: 'Mein Konto',
        options: 'Optionen',
        aide: 'Hilfe',
        mesDossiers: 'Meine Akten',
        nouveauDossier: 'Neue Akte',
        identiteTitre: 'Ihr Konto',
        formule: 'Tarif',
        situation: 'Status',
        debut: 'Seit dem',
        echeance: 'Bis zum',
        origine: 'Herkunft',
        origines: {
            stripe: 'Bezahltes Abonnement',
            code_essai: 'Testcode',
            geste: 'Kulanz',
        },
        statuts: {
            none: 'Kein Abonnement',
            trialing: 'Test läuft',
            active: 'Aktiv',
            past_due: 'Zahlung ausstehend',
            canceled: 'Gekündigt',
        },
        resiliationProgrammee: 'Ihr Abonnement endet mit dem laufenden Zeitraum.',
        essaiJusquau: (date) => `Kostenlos testen bis zum ${date}.`,
        accesCouvert: 'Ihr Schreibzugriff ist durch den Duo-Tarif offen, der für eine von Ihnen geteilte ' +
            'Akte abgeschlossen wurde. Sie können jederzeit ein eigenes Abonnement abschließen.',
        accesProfessionnel: 'Sie schreiben aufgrund eines von einem Elternteil geöffneten Fachzugangs, nicht aufgrund eines Abonnements.',
        factures: 'Meine Rechnungen und Zahlung',
        ouvertureFactures: 'Wird geöffnet…',
        facturesIndisponibles: 'Keine Rechnungen: Ihr Zugang kam nicht über eine Kartenzahlung zustande.',
        erreurFactures: 'Die Rechnungsseite konnte nicht geöffnet werden',
        dossiersTitre: 'Ihre Akten',
        parent: (rang) => `Elternteil ${rang}`,
        placeLibre: 'Noch frei',
        aucunDossier: 'Sie haben noch keine Akte.',
        optionsTitre: 'Optionen',
        retourPrecedent: 'Zurück',
        apparence: 'Erscheinungsbild',
        apparenceAide: '„Automatisch“ folgt der Einstellung Ihres Geräts: Es wird abends dunkler, ohne dass Sie daran denken müssen.',
        langueTitre: 'Sprache',
        langueAide: 'Die Sprache der Anwendung und ihrer E-Mails.',
        lectureIA: 'Belege lesen',
        lectureIAAide: 'Wenn Sie einer Ausgabe das Foto eines Belegs beifügen, kann Repère ihn lesen und ' +
            'Betrag, Datum und Kategorie vorschlagen. Das Foto geht allein zu diesem Zweck an ' +
            'Mistral, unseren europäischen KI-Dienstleister, und wird dort nicht gespeichert. Es ' +
            'ist das einzige Datum Ihrer Akte, das unsere Server verlässt.',
        lectureIAActive: 'Meine Belege lesen',
        lectureIAInactive: 'Nichts senden, ich gebe es selbst ein',
        notificationsTitre: 'Benachrichtigungen',
        silenceAide: 'In diesen Stunden bleibt Ihr Telefon still. Nichts geht verloren: Es wird ' +
            'zurückgehalten und am Ende der Ruhezeit auf einmal zugestellt.',
        silenceActive: 'Nachts Ruhe bewahren',
        silenceDesactive: 'Mich jederzeit benachrichtigen',
        silenceDebut: 'Ab',
        silenceFin: 'Bis',
        silenceNote: (fin) => `Was während der Ruhezeit eintrifft, erreicht Sie um ${fin} in einer einzigen ` +
            'Nachricht. Ein dringender Alarm kommt dennoch durch.',
        silenceNoteInactif: 'Sie werden benachrichtigt, sobald etwas geschieht — zu jeder Stunde.',
        emailTitre: 'E-Mails',
        emailAide: 'Diese Einstellung betrifft nur Ihr Postfach. An den Benachrichtigungen auf Ihrem ' +
            'Telefon ändert sie nichts.',
        emailImmediat: 'Jedes Mal eine E-Mail',
        emailQuotidien: 'Nur eine Zusammenfassung pro Tag',
        emailImmediatNote: 'Sie erhalten eine E-Mail, sobald etwas geschieht — außer während Ihrer Ruhezeiten.',
        emailQuotidienNote: (heure) => `Eine einzige E-Mail pro Tag, um ${heure}, mit der Anzahl der Ereignisse. Ihr Telefon ` +
            'benachrichtigt Sie weiterhin sofort. Ein dringender Alarm setzt sich darüber hinweg ' +
            'und wird sofort verschickt.',
        emailHeure: 'Zusammenfassung um',
        conges: 'Schulferien',
        congesAide: 'Woher Ihr Kalender die Ferientermine bezieht. Der amtliche Kalender deckt das ' +
            'französische Mutterland ab; eine .ics-Datei übernimmt für Überseegebiete, eine Schule ' +
            'im Ausland oder eine Einrichtung mit eigenen Terminen.',
        congesPartage: 'Diese Wahl gehört zur Akte: der andere Elternteil sieht denselben Kalender.',
        congesOfficiel: 'Amtlicher Kalender',
        congesOfficielZone: (zone) => `Zone ${zone}, abgeleitet aus der Postleitzahl der Schule.`,
        congesOfficielSansZone: 'Keine Zone ableitbar: Tragen Sie die Postleitzahl der Schule im Kinderprofil ein oder ' +
            'laden Sie eine Datei hoch.',
        congesFichier: 'Hochgeladene Datei',
        congesFichierAide: 'Eine .ics-Datei aus dem Kalender der Schule. Sie wird beim Hochladen gelesen und nicht ' +
            'aufbewahrt: nur ihre Termine.',
        congesDeposer: '.ics-Datei auswählen',
        congesDepotEnCours: 'Datei wird gelesen…',
        congesDepot: (nom, periodes) => `${nom} · ${periodes} Zeitraum${periodes > 1 ? 'e' : ''}`,
        congesCouverture: (debut, fin) => `Vom ${debut} bis ${fin}.`,
        congesRetirer: 'Diese Datei entfernen',
        congesErreur: 'Diese Datei konnte nicht gelesen werden',
        congesAucunDossier: 'Sie haben noch keine Akte einzurichten.',
        congesMemes: 'Ferien der Kinder',
        congesMemesOui: 'Für alle dieselben',
        congesMemesNon: 'Eine Einstellung je Kind',
        congesMemesAide: 'Eine Mittel- und eine Oberschule beiderseits einer Akademiegrenze genügen, um ' +
            'Geschwister zu trennen. Jedes Kind geht dann vom amtlichen Kalender SEINER Schule aus, ' +
            'und der Kalender umrandet seine Tage in seiner Farbe.',
        congesEnfant: (prenom) => `Ferien von ${prenom}`,
    },
    dates: {
        mois: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
        ],
        jour: 'Tag',
        moisLabel: 'Monat',
        annee: 'Jahr',
    },
    creerDossier: {
        titre: 'Akte anlegen',
        etapeSur4: (etape) => `Schritt ${etape} von 4`,
        erreurEtape: 'Dieser Schritt ist fehlgeschlagen',
        jalon: { enfants: 'Kinder', garde: 'Betreuung', invitation: 'Einladung', pret: 'Bereit' },
        etatJalon: { termine: 'erledigt', enCours: 'in Bearbeitung', aVenir: 'bevorstehend' },
        etape1: {
            titreCarte: 'Ihre Kinder',
            aideFratrie: 'Eine Akte umfasst die Kinder, die Sie mit demselben anderen Elternteil haben. Um ein Geschwisterkind zu einer bestehenden Akte hinzuzufügen, öffnen Sie diese und gehen Sie zu „Kinder“.',
            prenom: 'Vorname',
            dateNaissance: 'Geburtsdatum',
            suffixeRang: (index) => ` von Kind ${index + 1}`,
            enfantParDefaut: (index) => `Kind ${index + 1}`,
            retirer: 'Entfernen',
            retirerSuffixe: (index, prenom) => `: Kind ${index + 1}${prenom ? `, ${prenom}` : ''}`,
            ajouter: 'Ein weiteres Kind hinzufügen',
            continuer: 'Weiter',
        },
        etape2: {
            titreCarte: 'Das Betreuungsmodell',
            aideModification: 'Sie können es später ändern — jede Änderung erfordert die Zustimmung des anderen Elternteils.',
            schema: 'Modell',
            nidation: 'Nesting-Modell',
            nidationAide: 'Das Kind bleibt in der Familienwohnung, und die Eltern wechseln sich ab. Die Zeitaufteilung folgt weiterhin dem gewählten Modell.',
            dateDebut: 'Startdatum',
            heure: 'Übergabezeit',
            heureAide: 'Oft nach der Schule.',
            quiCommence: 'Wer beginnt',
            moi: 'Ich',
            autreParent: 'Der andere Elternteil',
            revenir: 'Zurück',
            creer: 'Akte anlegen',
            creationEnCours: 'Wird angelegt…',
        },
        etape3: {
            titreCarte: 'Den anderen Elternteil einladen',
            intro: 'Repère schützt beide Elternteile gleichermaßen: Der andere Elternteil erhält genau dieselben Rechte wie Sie an dieser Akte, und keiner von beiden kann dem anderen etwas entziehen.',
            redaction: 'Die Nachricht wird von Repère in neutralem Ton verfasst. Sie müssen nichts schreiben.',
            email: 'E-Mail-Adresse des anderen Elternteils',
            plusTard: 'Später',
            envoyer: 'Einladung senden',
            envoiEnCours: 'Wird gesendet…',
        },
        etape4: {
            titreCarte: 'Ihre Akte ist bereit',
            messageAvecInvitation: 'Die Einladung wurde versendet. Die Akte ist ab sofort nutzbar, ohne auf eine Antwort zu warten.',
            messageSansInvitation: 'Die Akte ist ab sofort nutzbar. Sie können den anderen Elternteil einladen, wann immer Sie möchten.',
            ouvrir: 'Akte öffnen',
        },
        residence: {
            pays: 'Wohnsitzland des Kindes',
            ville: 'Wohnort des Kindes',
            zone: (zone) => `Schulferienzone ${zone}.`,
            zoneInconnue: 'Zone nicht erkannt — die genaue Schreibweise der Gemeinde hilft, sie zu finden.',
        },
    },
    entree: {
        presentation: {
            accrocheCourte: 'Der Betreuungskalender, die Nachrichten und die Unterlagen Ihrer Kinder, alles an einem Ort.',
            accrocheLongue: 'Repère ist das Werkzeug für getrennt lebende Eltern: der Betreuungskalender, die Nachrichten und die Unterlagen Ihrer Kinder, alles an einem Ort.',
            publics: 'Es richtet sich an beide Elternteile, unabhängig vom Betreuungsmodell und unabhängig vom Zustand Ihrer Beziehung. Ein Anwalt, Mediator oder Sozialarbeiter kann als Leser eingeladen werden, wenn einer von Ihnen das entscheidet.',
            garanties: 'Alles wird von unseren Servern zeitgestempelt, und nichts kann danach mehr geändert oder gelöscht werden — weder von Ihnen, noch vom anderen Elternteil, noch von unserem Team. Jeder hat genau dieselben Rechte und sieht genau dasselbe.',
        },
        modesAcces: {
            titre: 'Haben Sie eine Einladung erhalten?',
            autreParentTitre: 'Sie sind der andere Elternteil',
            autreParentTexte: 'Der Akte beizutreten ist kostenlos: Registrierung und Kalender erfordern kein Abonnement. Jeder kann anschließend sein eigenes abschließen, wenn er möchte — 9,90 € im Monat — und keiner kann dem anderen den Zugang entziehen.',
            proTitre: 'Sie sind Anwalt, Mediator oder Sozialarbeiter',
            proTexte: 'Ihr Konto ist kostenlos, ohne Beschränkung der Akten. Sie erhalten Lesezugriff auf das, was ein Elternteil Ihnen freigibt, für die von ihm bestimmte Dauer. Der andere Elternteil wird über Ihre Ankunft informiert: Niemand betritt eine Akte, ohne dass es jemand weiß.',
        },
        fournisseurs: {
            indisponible: 'Demnächst verfügbar',
            separateurOu: 'oder',
            intro: 'Mit einem Konto, das Sie schon haben — kein neues Passwort zu merken.',
            redirection: (nom) => `Weiterleitung zu ${nom}…`,
            verbeAvec: (verbe, nom) => `${verbe} mit ${nom}`,
            indisponibleDetail: 'Demnächst verfügbar. E-Mail-Adresse und Passwort geben Zugang zum gesamten Produkt: Keine Funktion wird jemals von einem Konto eines Drittanbieters abhängen.',
        },
        feuille: {
            fermer: 'Schließen',
        },
        connexion: {
            titre: 'Anmelden',
            verbe: 'Anmelden',
            pasDeCompte: 'Noch kein Konto?',
            sInscrire: 'Registrieren',
            email: 'E-Mail-Adresse',
            motDePasse: 'Passwort',
            motDePasseOublie: 'Passwort vergessen?',
            connexionEnCours: 'Anmeldung läuft…',
            erreurTitre: 'Anmeldung nicht möglich',
            echecRefus: 'Die Anmeldung wurde unterbrochen. Sie können es erneut versuchen oder Ihre E-Mail-Adresse und Ihr Passwort eingeben.',
            echecExpire: 'Die Anmeldung hat zu lange gedauert. Bitte versuchen Sie es erneut.',
            echecGenerique: 'Die Anmeldung über diesen Anbieter war nicht erfolgreich. Sie können stattdessen Ihre E-Mail-Adresse und Ihr Passwort eingeben.',
        },
        inscription: {
            titre: 'Konto erstellen',
            verbe: 'Registrieren',
            motDePasseTropCourt: 'Das Passwort muss mindestens 12 Zeichen lang sein.',
            verifiezBoite: 'Prüfen Sie Ihr Postfach',
            siAdresseUtilisable: 'Falls diese Adresse verwendet werden kann, wurde soeben eine Nachricht dorthin gesendet. Öffnen Sie den darin enthaltenen Link, um Ihre Adresse zu bestätigen.',
            dejaConnexionPossible: 'Sie können sich bereits anmelden: Die Bestätigung kann warten.',
            dejaCompte: 'Sie haben bereits ein Konto?',
            seConnecter: 'Anmelden',
            prenom: 'Vorname',
            prenomAide: 'Wird dem anderen Elternteil angezeigt.',
            email: 'E-Mail-Adresse',
            motDePasse: 'Passwort',
            motDePasseAide: 'Mindestens 12 Zeichen. Ein Satz, den Sie sich merken, ergibt ein gutes Passwort.',
            erreurTitre: 'Konto konnte nicht erstellt werden',
            creationEnCours: 'Wird erstellt…',
            creerMonCompte: 'Mein Konto erstellen',
            echecGenerique: 'Etwas hat nicht funktioniert. Versuchen Sie es gleich noch einmal.',
        },
    },
    dossier: {
        categories: {
            aujourdhui: 'Heute',
            calendrier: 'Kalender',
            messages: 'Nachrichten',
            depenses: 'Ausgaben',
            journal: 'Journal',
            enfants: 'Kinder',
        },
        navigation: {
            ariaCategories: 'Kategorien der Akte',
            reserveParent: 'Den Tarifen Solo und Duo vorbehalten. Bereits Gespeichertes bleibt lesbar.',
            reserveParentSuffixe: ', den Tarifen Solo und Duo vorbehalten',
            nouveaute: (n) => accorder('de', n, { one: '1 Neuigkeit', other: `${n} Neuigkeiten` }),
        },
        calendrier: {
            moisPrecedent: 'Vorheriger Monat',
            moisSuivant: 'Nächster Monat',
            erreurChargement: 'Der Kalender konnte nicht geladen werden',
            titre: (moisEtAnnee) => `Betreuungskalender — ${moisEtAnnee}`,
            chezVous: 'Bei Ihnen',
            chezAutre: (nom) => `Bei ${nom}`,
            nonDefini: 'nicht festgelegt',
            libelleEchange: 'Tagestausch',
            libelleDerogation: 'vereinbarte Ausnahme',
            titreEchange: 'Vereinbarter Tagestausch',
            titreDerogationConvenue: 'Vereinbarte Ausnahme',
            avecMotif: (base, motif) => `${base} — ${motif}`,
            suffixeDerogation: (libelle) => `, ${libelle}`,
            suffixeMotif: (motif) => `, Grund: ${motif}`,
            marqueEchange: 'Getauscht',
            legendeEchange: 'Tag im gegenseitigen Einvernehmen getauscht',
            suffixeConge: ' — Schulferien',
            suffixeCongeEnfants: (prenoms) => ` — Schulferien: ${prenoms}`,
            legendeConge: (zone) => `Schulferien · Zone ${zone}`,
            legendeCongeFichier: 'Schulferien · hochgeladene Datei',
            legendeCongeEnfant: (prenom, source) => `${prenom} — ${source}`,
            legendeCongesAbsents: 'Schulferien: nichts anzuzeigen. Tragen Sie die Postleitzahl der Schule im ' +
                'Kinderprofil ein oder laden Sie unter „Mein Konto › Optionen“ eine Feriendatei hoch.',
        },
        journal: {
            ariaFiltrer: 'Journal filtern',
            filtreTout: 'Alle',
            filtrePartagees: 'Geteilt',
            filtrePrivees: 'Privat',
            entreeSuffixe: (n) => accorder('de', n, { one: ', 1 Eintrag', other: `, ${n} Einträge` }),
            erreurChargement: 'Das Journal konnte nicht geladen werden',
            modeSoloTexte: 'Sie sind vorerst allein auf dieser Akte, und das Journal funktioniert normal. Wenn der andere Elternteil später beitritt, sieht er die Einträge, die Sie als geteilt markiert haben, mit ihrem ursprünglichen Datum.',
            videTout: 'Noch keine Einträge.',
            videPartagees: 'Keine geteilten Einträge.',
            videPrivees: 'Keine privaten Einträge.',
            auteurVous: 'Sie',
            auteurAutreParent: 'Der andere Elternteil',
            marquePrivee: 'Privat',
            marquePartagee: 'Geteilt',
            invisibleSuffixePrivee: 'Privater Eintrag, nur für Sie sichtbar, unveränderlich.',
            invisibleSuffixePartagee: 'Mit dem anderen Elternteil geteilter Eintrag, unveränderlich.',
            mentionImmuable: 'Jeder Eintrag wird von unseren Servern zeitgestempelt und kann danach nicht mehr geändert oder gelöscht werden — weder von Ihnen, noch vom anderen Elternteil, noch von unserem Team. Halten Sie Fakten fest: was geschah, wann.',
            mentionImmuableBouton: 'Unveränderlichkeit des Journals',
            labelFait: 'Der festzuhaltende Sachverhalt',
            placeholderFait: 'Der festzuhaltende Sachverhalt — „Ubergabe um 18:05 Uhr erfolgt“',
            ariaQuiPeutVoir: 'Wer kann diesen Eintrag sehen?',
            intituleVisiblePar: 'Sichtbar für',
            visibiliteAutre: 'Der andere Elternteil',
            visibiliteAutreAide: 'Er erscheint identisch im Journal beider Elternteile.',
            visibiliteMoi: 'Nur Sie',
            visibiliteMoiAide: 'Der andere Elternteil wird nicht informiert. Er erscheint nur in Ihrem eigenen Export.',
            aideChoixDefaut: 'Wählen Sie, wer diesen Eintrag sehen wird: nichts ist vorab angekreuzt.',
            enregistrementEnCours: 'Wird gespeichert…',
            consigner: 'Festhalten',
            erreurEnregistrement: 'Der Eintrag konnte nicht gespeichert werden',
            reformuler: 'Formuliere diesen Text für mich um',
            reformulationEnCours: 'Wird umformuliert…',
            reformulationTitre: 'Eine andere Art, es zu sagen',
            reformulationAide: 'Nichts wird gespeichert: weder Ihr Entwurf noch dieser Vorschlag — niemand ' +
                'erfährt, dass Sie ihn angefordert haben.',
            reformulationUtiliser: 'Diese Fassung übernehmen',
            reformulationGarder: 'Meinen Text behalten',
            reformulationDejaNeutre: 'Ihr Text ist bereits sachlich: Es gibt nichts abzumildern.',
            reformulationIndisponible: 'Das Umformulieren ist derzeit nicht verfügbar. Sie können Ihren Text unverändert festhalten.',
            reformulationBudget: 'Sie haben Ihre heutigen Umformulierungen aufgebraucht. Sie kehren morgen zurück.',
            reformulationTropLong: 'Dieser Text ist zu lang zum Umformulieren.',
        },
        depenses: {
            statutAttente: 'Antwort ausstehend',
            statutAcceptee: 'Akzeptiert',
            statutContestee: 'Angefochten',
            statutRemboursee: 'Erstattet',
            categories: ['Gesundheit', 'Schule', 'Kantine', 'Aktivitäten', 'Kleidung', 'Transport'],
            comptesAJour: 'Die Abrechnung ist auf dem neuesten Stand.',
            soldePhrase: (debiteur, jeSuisDebiteur, montant, crediteur) => jeSuisDebiteur
                ? `Sie schulden ${crediteur} ${montant}.`
                : `${debiteur} schuldet ${crediteur} ${montant}.`,
            detailLigneALigne: 'Die Aufstellung, Zeile für Zeile',
            ligneDetail: (date, categorie, montant, payeur, montantAutre) => `${date} — ${categorie}: ${montant} vorgestreckt von ${payeur}, davon ${montantAutre} zulasten des anderen.`,
            soldeNonStocke: 'Dieser Saldo wird nirgends gespeichert: Er wird bei jeder Anzeige aus diesen Zeilen neu berechnet. Sie können die Summe selbst nachrechnen.',
            sansRegleTitre: 'Einige Ausgaben warten auf eine Aufteilungsregel',
            sansRegleTexte: (n) => accorder('de', n, {
                one: '1 Ausgabe liegt vor jeder Regel und wird nicht mitgezählt.',
                other: `${n} Ausgaben liegen vor jeder Regel und werden nicht mitgezählt.`,
            }),
            erreurChargement: 'Die Ausgaben konnten nicht geladen werden',
            declarerUneDepense: 'Eine Ausgabe melden',
            justificatifAnalyse: 'Geprüft, verschlüsselt und den Dokumenten der Akte beigefügt.',
            lectureTitre: 'Den Beleg für Sie lesen?',
            lectureQuestion: 'Repère kann das Foto Ihres Belegs lesen und Betrag, Datum und Kategorie ' +
                'vorschlagen. Sie prüfen, korrigieren und bestätigen.',
            lectureDetail: 'Das Foto wird allein zu diesem Zweck an Mistral gesendet, unseren europäischen ' +
                'KI-Dienstleister. Es wird dort nicht gespeichert, und wir behalten ebenfalls nichts. ' +
                'Es ist das einzige Datum Ihrer Akte, das unsere Server verlässt — Sie können diese ' +
                'Zustimmung jederzeit unter „Optionen“ zurückziehen.',
            lectureAccepter: 'Ja, meine Belege lesen',
            lectureRefuser: 'Nein, ich gebe es selbst ein',
            lectureEnCours: 'Beleg wird gelesen…',
            lectureProposee: 'Betrag, Datum, Kategorie und Kommentar aus dem Beleg vorgeschlagen. Bitte prüfen.',
            commentaire: 'Kommentar',
            commentairePlaceholder: 'Apotheke am Markt — Antibiotika und Verbandsmaterial',
            commentaireAide: 'Optional. Was auf dem Beleg steht: das Geschäft, das Gekaufte. Das Auslesen des Belegs ' +
                'kann ihn vorschlagen; Sie prüfen ihn.',
            lectureRien: 'Auf diesem Foto war nichts zu lesen. Bitte die Ausgabe von Hand eingeben.',
            lectureIndisponible: 'Das Lesen ist derzeit nicht verfügbar. Bitte die Ausgabe von Hand eingeben.',
            lectureBudget: 'Sie haben Ihre Lesungen für heute aufgebraucht. Morgen gibt es wieder welche.',
            lectureQuota: 'Diese Akte hat ihre fünf Lesungen für heute aufgebraucht. Morgen gibt es wieder welche.',
            retirer: 'Entfernen',
            photographierLeTicket: 'Beleg fotografieren',
            choisirUnFichier: 'Datei auswählen',
            envoiEnCours: 'Wird gesendet…',
            justificatifAide: 'Optional, aber entscheidend, falls die Ausgabe angefochten wird. PDF oder Foto.',
            erreurJustificatif: 'Der Beleg konnte nicht angehängt werden',
            montant: 'Betrag',
            montantInvalide: 'Ungültiger Betrag.',
            dateDeLaDepense: 'Datum der Ausgabe',
            ariaCategorie: 'Kategorie der Ausgabe',
            erreurDeclaration: 'Die Ausgabe konnte nicht gespeichert werden',
            enregistrementEnCours: 'Wird gespeichert…',
            declarerLaDepense: 'Ausgabe melden',
            aideAvecCategorie: 'Das gewählte Datum bestimmt die angewendete Aufteilungsregel.',
            aideSansCategorie: 'Wählen Sie eine Kategorie: nichts ist voreingestellt.',
            unParent: 'Ein Elternteil',
            vous: 'Sie',
            justificatifJoint: 'Beleg angehängt',
            avancePar: (date, payeur) => `${date} · vorgestreckt von ${payeur}`,
            accepter: 'Akzeptieren',
            motifSiConteste: 'Grund, falls Sie widersprechen',
            motifAide: 'Ein Widerspruch ohne Grund führt zu nichts: sagen Sie, was das Problem ist.',
            contester: 'Anfechten',
            videListe: 'Noch keine Ausgaben.',
            ongletDetail: 'Details',
            ongletPartagees: 'Gemeinsame Ausgaben',
        },
        messagerie: {
            ariaFils: 'Gesprächsthemen',
            filTous: 'Alle',
            filSansFil: 'Ohne Thema',
            filSante: 'Gesundheit',
            filEcole: 'Schule',
            filVacances: 'Ferien',
            filUrgences: 'Notfälle',
            messageSuffixe: (n) => accorder('de', n, { one: ', 1 Nachricht', other: `, ${n} Nachrichten` }),
            erreurChargement: 'Die Nachrichten konnten nicht geladen werden',
            ouvrirLaPieceJointe: 'Anhang öffnen',
            erreurOuverturePiece: 'Der Anhang konnte nicht geöffnet werden',
            pieceJointeScellee: 'Mit der Nachricht versiegelt: ein Ersetzen würde ihren Fingerabdruck zerstören.',
            redactionPieceScellee: (nomFichier) => `${nomFichier} — geprüft, verschlüsselt und sein Fingerabdruck mit der Nachricht versiegelt: ein späteres Ersetzen würde die Kette brechen.`,
            videAucun: 'Noch keine Nachrichten.',
            videAucunDansCeFil: 'Keine Nachrichten in diesem Thema.',
            nouveauxMessages: (n) => accorder('de', n, { one: '1 neue Nachricht', other: `${n} neue Nachrichten` }),
            vosEnvoisDifferes: 'Ihre geplanten Sendungen',
            envoisDifferesAide: 'Nur für Sie sichtbar, solange sie nicht versendet wurden. Sie können sie noch stornieren.',
            envoiPrevu: (corps, date, heureTexte) => `„${corps}“ — Versand geplant am ${date} um ${heureTexte}`,
            annulerCetEnvoi: 'Diesen Versand stornieren',
            retirer: 'Entfernen',
            mentionImmuable: 'Hier ausgetauschte Nachrichten können weder geändert noch gelöscht werden — weder von Ihnen, noch vom anderen Elternteil, noch von unserem Team. Jede wird von unseren Servern zeitgestempelt.',
            mentionImmuableBouton: 'Unveränderlichkeit der Nachrichten',
            reformuler: 'Formuliere diese Nachricht für mich um',
            reformulationEnCours: 'Wird umformuliert…',
            reformulationTitre: 'Eine andere Art, es zu sagen',
            reformulationAide: 'Es wurde nichts gesendet und nichts gespeichert: weder Ihr Entwurf noch dieser ' +
                'Vorschlag. Der andere Elternteil erfährt nicht, dass Sie ihn angefordert haben.',
            reformulationUtiliser: 'Diese Fassung übernehmen',
            reformulationGarder: 'Meinen Text behalten',
            reformulationDejaNeutre: 'Ihre Nachricht ist bereits sachlich: Es gibt nichts abzumildern.',
            reformulationIndisponible: 'Das Umformulieren ist derzeit nicht verfügbar. Ihre Nachricht geht unverändert raus.',
            reformulationBudget: 'Sie haben Ihre Umformulierungen für heute aufgebraucht. Morgen gibt es wieder welche.',
            reformulationTropLong: 'Diese Nachricht ist zu lang zum Umformulieren.',
            votreMessage: 'Ihre Nachricht',
            placeholderEcrire: 'Eine Nachricht schreiben…',
            joindreUnDocument: 'Ein Dokument anhängen',
            envoyerPlusTard: 'Später senden',
            envoiEnCours: 'Wird gesendet…',
            programmerLEnvoi: 'Versand planen',
            envoyer: 'Senden',
            dateEtHeureEnvoi: 'Datum und Uhrzeit des Versands',
            aideHorodatage: 'Maßgeblich ist der Zeitstempel des tatsächlichen Versands.',
            erreurEnvoi: 'Die Nachricht konnte nicht gesendet werden',
            inactiveTexte: 'Die Nachrichtenfunktion wird aktiviert, sobald der andere Elternteil der Akte beigetreten ist: Ohne Gesprächspartner hat sie keinen Zweck.',
            auteurVous: 'Sie',
            auteurAutreParent: 'Der andere Elternteil',
            messageInvisible: (date, heureTexte, numero) => `${date} um ${heureTexte}. Nachricht Nummer ${numero}, unveränderlich.`,
        },
        suppression: {
            ouvrir: 'Diese Akte löschen',
            titre: 'Diese Akte löschen',
            texte: 'Über das Löschen wird gemeinsam entschieden: Der andere Elternteil erhält eine ' +
                'Nachricht und muss bestätigen. Nach der Bestätigung bleibt die Akte dreißig Tage ' +
                'lesbar, ohne bearbeitet werden zu können, danach wird sie endgültig zerstört. In ' +
                'dieser Zeit kann jeder von beiden alles rückgängig machen.',
            texteSolo: 'Sie sind allein in dieser Akte: Die Bestätigungsnachricht geht an Sie. Nach der ' +
                'Bestätigung bleibt die Akte dreißig Tage lesbar, ohne bearbeitet werden zu können, ' +
                'danach wird sie endgültig zerstört. Bis zum letzten Tag können Sie alles ' +
                'rückgängig machen.',
            demander: 'Löschung beantragen',
            envoiEnCours: 'Wird gesendet…',
            erreur: 'Der Antrag konnte nicht gesendet werden',
            renoncer: 'Nicht löschen',
            attenteAutre: 'Die Löschung dieser Akte wurde beantragt. Der andere Elternteil hat eine Nachricht ' +
                'erhalten: Sie wird nur wirksam, wenn er sie bestätigt.',
            attenteVous: 'Die Löschung dieser Akte wurde beantragt. Sie haben eine Nachricht erhalten: ' +
                'öffnen Sie sie, um zu bestätigen oder abzulehnen.',
            attenteEcheance: (date) => `Ohne Antwort verfällt dieser Antrag am ${date} von selbst.`,
            archiveTitre: 'Archivierte Akte',
            archiveTexte: (date) => `Diese Akte wird am ${date} endgültig zerstört.`,
            archiveLecture: 'Bis dahin bleibt sie lesbar — Sie können sie nachlesen und einen Export anfordern — ' +
                'aber niemand kann mehr hineinschreiben.',
            annuler: 'Löschung abbrechen',
            annulationEnCours: 'Wird abgebrochen…',
        },
        ecran: {
            modeSolo: `Sie nutzen diese Akte allein`,
            modePartage: `Geteilte Akte · identische Rechte`,
            modePartageAvec: (prenom) => `Geteilt mit ${prenom} · identische Rechte`,
            quiALEnfant: `Wer hat das Kind?`,
            quiReponseVous: `Das Kind ist bei Ihnen`,
            quiReponseAutre: (prenom) => `Das Kind ist bei ${prenom}`,
            quiAucunSchema: `Kein Betreuungsmodell deckt dieses Datum ab`,
            quiDerogation: `Nach vereinbarter Ausnahme.`,
            quiRecherche: `Wird geprüft…`,
            quiErreur: `Die Antwort konnte nicht abgerufen werden`,
            quiDateAujourdhui: (date) => `Heute, ${date}`,
            quiQuelleDate: `Welches Datum?`,
            quiAutreJour: `Anderen Tag ansehen`,
            quiRevenirAujourdhui: `Zurück zu heute`,
            demandesAccord: `Zustimmungsanfragen`,
            ongletNouveautes: `Neues`,
            ongletDossier: `Die Akte`,
            modeSoloTexte: `Der Kalender, das Journal und die Dokumente funktionieren normal. Alles, was Sie dort festhalten, wird ab sofort zeitgestempelt.`,
            invitationEnvoyeeTexte: `Eine Einladung wurde versendet. Sie bleibt 30 Tage gültig.`,
            renvoyerOuCorriger: `Adresse erneut senden oder korrigieren`,
            nouvelleAdresseRemplace: `Die neue Adresse ersetzt die vorherige: Der bereits gesendete Link wird ungültig.`,
            peutInviterQuandVeut: `Sie können den anderen Elternteil einladen, wann immer Sie möchten.`,
            erreurInvitation: `Die Einladung konnte nicht gesendet werden`,
            emailAutreParent: `E-Mail-Adresse des anderen Elternteils`,
            aideInvitation: `Die Nachricht wird von Repère in neutralem Ton verfasst.`,
            envoiEnCours: `Wird gesendet…`,
            envoyerInvitation: `Einladung senden`,
            calendrierDeGarde: `Der Betreuungskalender`,
            demanderEchange: `Tagestausch anfragen`,
            historiqueSchema: `Verlauf des Betreuungsmodells`,
            depensesPartagees: `Gemeinsame Ausgaben`,
            ficheDe: (prenom) => `Profil von ${prenom}`,
        },
    },
    schemasDeGarde: {
        schemas: {
            alternating_week: {
                libelle: 'Wechselwoche (7/7)',
                detail: 'Eine Woche bei dem einen, eine Woche bei dem anderen. Das häufigste Modell.',
            },
            two_two_five_five: {
                libelle: '2-2-5-5',
                detail: 'Zwei feste Tage bei jedem pro Woche, dann fünf Tage einschließlich Wochenende.',
            },
            two_two_three: {
                libelle: '2-2-3',
                detail: 'Zwei Nächte, zwei Nächte, drei Nächte: für jüngere Kinder gedacht.',
            },
            three_four_four_three: {
                libelle: '3-4-4-3',
                detail: 'Wechsel in der Wochenmitte, über einen Zwei-Wochen-Zyklus.',
            },
            fortnight: {
                libelle: 'Zweiwöchiger Wechsel (14/14)',
                detail: 'Zwei Wochen bei jedem: Jugendliche, oder große Entfernung.',
            },
            nine_five: {
                libelle: '9/5-Wechsel',
                detail: 'Neun Nächte beim einen, fünf beim anderen, über einen Zwei-Wochen-Zyklus.',
            },
            ten_four: {
                libelle: '10/4-Wechsel',
                detail: 'Zehn Nächte beim einen, vier beim anderen, über einen Zwei-Wochen-Zyklus.',
            },
            alternate_weekends: {
                libelle: 'Wechselnde Wochenenden (1., 3., 5.)',
                detail: 'Klassisches Besuchs- und Übernachtungsrecht: jedes zweite Wochenende, Freitag bis Sonntag.',
            },
            extended_weekends: {
                libelle: 'Erweiterte wechselnde Wochenenden',
                detail: 'Erweitertes Besuchsrecht: jedes zweite Wochenende, von Freitagabend bis Montagmorgen.',
            },
            visits_only: {
                libelle: 'Besuche ohne Übernachtung',
                detail: 'Eingeschränktes Besuchsrecht: nur tagsüber, keine Übernachtung. Jeder Besuch wird im Kalender eingetragen.',
            },
            holidays_only: {
                libelle: 'Nur Schulferien',
                detail: 'Besuchsrecht bei großer Entfernung: keine regelmäßigen Wochenenden, der Großteil der Ferien.',
            },
            third_party: {
                libelle: 'Wohnsitz bei einem Dritten',
                detail: 'Das Kind wohnt bei einem Dritten; die Zeiten jedes Elternteils werden einzeln festgelegt.',
            },
            custom: {
                libelle: 'Individuell',
                detail: 'Keine automatische Erstellung: Der Kalender wird zeitraumweise aufgebaut.',
            },
        },
        familles: {
            alternance: 'Wechselmodell',
            alternance_inegale: 'Ungleiches Wechselmodell',
            residence_principale: 'Hauptwohnsitz bei einem Elternteil',
            autre: 'Sonstiges',
        },
    },
    apercu: {
        titre: 'Vorschau des Wechselmodells',
        pasDeCycle: (libelle) => `„${libelle}“ hat keinen Zyklus zum Abspielen: Die Zeiten jedes Elternteils werden zeitraumweise im Kalender der Akte festgelegt. Es gibt hier daher nichts als Vorschau zu zeigen.`,
        choisirDate: 'Wählen Sie ein Startdatum: Die Vorschau zeigt dann die ersten drei Monate, Tag für Tag.',
        aPartirDu: (date) => `Ab dem ${date}:`,
        joursChezVous: (n) => accorder('de', n, { one: '1 Tag bei Ihnen', other: `${n} Tage bei Ihnen` }),
        etJoursChezAutre: (n) => `und ${n} beim anderen Elternteil, über die gezeigten drei Monate.`,
        chezVousInvisible: ', bei Ihnen',
        chezAutreInvisible: ', beim anderen Elternteil',
        legendeChezVous: 'Bei Ihnen',
        legendeChezAutre: 'Beim anderen Elternteil',
        legendePassage: 'Übergabe',
    },
    site: {
        nav: {
            accueil: 'Startseite',
            tarifs: 'Preise',
            connexion: 'Anmelden',
            inscription: 'Registrieren',
        },
        footer: {
            accroche: 'Organisation und Gelassenheit für getrennte Eltern. Gehostet in Frankreich, keine Tracker, keine Drittanbieter-Cookies.',
            produit: 'Produkt',
            tarifsLien: 'Preise',
            applicationsLien: 'Mobile Apps',
            legal: 'Rechtliches',
            mentionsLegales: 'Impressum',
            confidentialite: 'Datenschutzerklärung',
            pied: (annee) => `Repère-kids — ${annee}. In Frankreich gehostet.`,
            version: (version, horodatage) => `Version ${version} — Build vom ${horodatage}`,
        },
        accueil: {
            titre: 'Koordination für getrennte Eltern',
            description: 'Repère: Betreuungskalender, geteilte Ausgaben, zeitgestempelte Nachrichten und eine unveränderliche Historie für getrennte Eltern.',
            badgeConfiance: 'Gehostet in Frankreich · Kein Tracker',
            h1: 'Koordination, ohne dass jeder Austausch zur Verhandlung wird.',
            accroche: 'Ein Betreuungskalender, geteilte Ausgaben, Dokumente, Nachrichten — und eine zeitgestempelte Spur, die kein Elternteil umschreiben kann.',
            etrePrevenu: 'Bei Start benachrichtigt werden',
            pointChiffre: 'Pro Fall verschlüsselt',
            pointServeurs: 'Server in Frankreich',
            pointHistorique: 'Unveränderliche Historie',
            question: 'Wer hat die Kinder am Mittwoch?',
            reponseForte: 'Mittwoch, 16. September — bei Ihnen',
            reponseSuite: 'Nächste Übergabe: Freitag, 18., 16:30 Uhr',
            moisCarte: 'September 2026',
            legendeChezVous: 'Bei Ihnen',
            legendeChezAutre: 'Beim anderen Elternteil',
            captureAlt: 'Bildschirmfoto von Repère-kids: der Betreuungskalender eines geteilten Falls, August 2026.',
            captureLegende: 'Die App, Kalenderansicht. Beispieldaten.',
            surTitreChange: 'Was Repère verändert',
            titreChange: 'Drei Fragen, über die nicht mehr diskutiert werden muss',
            introChange: 'Der Kalender, die Vereinbarungen und die Historie — jeweils ein für alle Mal vom Produkt geregelt, nicht von Ihnen.',
            carte1Titre: 'Ein Kalender, der sofort antwortet',
            carte1Texte: 'Wer hat das Kind am Mittwoch? Die Antwort steht auf dem Bildschirm, für heute wie für jedes andere Datum.',
            carte2Titre: 'Datierte Vereinbarungen',
            carte2Texte: 'Ein Tausch von Tagen wird vorgeschlagen, angenommen oder abgelehnt. Jeder Schritt wird festgehalten — niemand muss sich merken, wer was gesagt hat.',
            carte3Titre: 'Eine Historie, die niemandem gehört',
            carte3Texte: 'Weder Sie noch der andere Elternteil noch unser Support können ändern oder löschen, was geteilt wurde.',
            surTitreParti: 'Grundhaltung',
            titreParti: 'So gebaut, dass es nie zur Waffe wird',
            texteParti: 'Repère hält Fakten fest; es interpretiert sie nicht und inszeniert sie nicht. Beide Elternteile haben genau dieselben Rechte — keiner kann den anderen ausschließen oder etwas aus der gemeinsamen Historie entfernen.',
            absencesIntitule: 'Was Sie hier nicht finden',
            absence1: 'Lesebestätigung',
            absence2: 'Status „online“, „zuletzt gesehen“, „letzte Anmeldung“',
            absence3: 'Verspätungszähler, Verhaltensbewertung',
            absence4: '„Eigentümer“-Konto des Falls',
            surTitreAcces: 'Zugangswege',
            titreAcces: 'Haben Sie eine Einladung erhalten?',
            introAcces: 'Die Frage stellt sich, bevor ein Konto angelegt wird — deshalb kommt die Antwort vor dem Formular.',
            acces1Titre: 'Sie sind der andere Elternteil',
            acces1Texte: 'Einem Fall beizutreten ist kostenlos: Registrierung und Kalender erfordern kein Abonnement. Jeder kann anschließend selbst abonnieren, wenn gewünscht — 9,90 € pro Monat — und niemand kann dem anderen den Zugang sperren.',
            acces1Badge: 'Kostenlos',
            acces2Titre: 'Sie sind Anwalt, Mediator oder Sozialarbeiter',
            acces2Texte: 'Ihr Konto ist kostenlos, ohne Begrenzung der Fälle. Sie erhalten Lesezugriff auf das, was ein Elternteil Ihnen öffnet, für die von ihm festgelegte Dauer. Der andere Elternteil wird über Ihren Zugang informiert: Niemand betritt einen Fall ohne Wissen der anderen Person.',
            acces2Badge: 'Kostenlos, unbegrenzt',
            acces3Titre: 'Sie schauen sich um, ohne etwas erhalten zu haben',
            acces3Texte: 'Tragen Sie sich in die Warteliste ein, um bei der Eröffnung benachrichtigt zu werden. Sie legen erst dann einen Fall an, wenn Sie sich entscheiden, den anderen Elternteil einzuladen.',
            acces3Badge: 'Ohne Konto',
            surTitreTarifs: 'Preise',
            titreTarifs: 'Ein Abonnement pro Elternteil. Sonst nichts.',
            introTarifs: 'Keine „Premium“-Version, die Rechte über den anderen freischaltet: Beide Elternteile sehen dasselbe, unabhängig vom Abonnement.',
            basculeLegende: 'Abrechnungszeitraum',
            basculeMensuel: 'Monatlich',
            basculeAnnuel: 'Jährlich',
            tarifRejoindreTitre: 'Link',
            tarifRejoindrePrix: '0 €',
            tarifRejoindreTexte: 'Für den Elternteil, der zu einem bestehenden Fall eingeladen wird.',
            tarifRejoindreAvantage1: 'Geteilter Betreuungskalender',
            tarifRejoindreAvantage2: 'Vollständiger Lesezugriff auf die Historie',
            tarifRejoindreAvantage3: 'Keine Frist',
            tarifParentTitre: 'Solo',
            tarifParentEtiquette: 'Am häufigsten',
            tarifParentPrixMensuel: '9,90 € / Monat, pro Elternteil',
            tarifParentPrixMensuelDuo: '14,90 € / Monat, für beide Elternteile',
            tarifParentPrixAnnuelSeul: '99 € / Jahr, pro Elternteil',
            tarifParentPrixAnnuelDuo: '149 € / Jahr, für beide Elternteile',
            tarifParentPrixAnnuel: 'Zwei Monate geschenkt gegenüber dem Monatstarif.',
            tarifParentEssaiGratuit: '7 Tage kostenlos testen',
            tarifParentBoutonNotification: 'Meinen Frühbucher-Zugang sichern',
            tarifParentSwitchDuo: 'Den anderen Elternteil einschließen',
            tarifParentEarlybirdEtiquette: 'Frühbucher',
            tarifParentEarlybirdTexte: '79 € im ersten Jahr für Warteliste-Anmeldungen, danach Jahrestarif.',
            tarifParentEarlybirdTexteDuo: '129 € im ersten Jahr für Warteliste-Anmeldungen, danach Jahrestarif.',
            tarifParentEngagement: 'Monatlich kündbar. Mit einem Klick über Ihr Konto kündbar.',
            tarifParentOptionDeuxEtiquette: 'Duo',
            tarifParentOptionDeuxTexte: '+ 5 € pro Monat, also 14,90 € insgesamt, um auch das Abonnement des anderen Elternteils abzudecken.',
            tarifParentOptionDeuxTexteAnnuel: '+ 50 € pro Jahr, also 149 € insgesamt, um auch das Abonnement des anderen Elternteils abzudecken.',
            tarifParentAvantage1: 'Alles aus Link',
            tarifParentAvantage2: 'Nachrichten, geteilte Ausgaben, verschlüsselte Dokumente',
            tarifParentAvantage3: 'Tauschvorschläge und Journal',
            tarifParentAvantage4: 'Zeitgestempelter Export des Falls',
            tarifParentAvantage5: 'Einladung einer Fachperson mit Lesezugriff',
            tarifProTitre: 'Pro',
            tarifProPrix: '0 €',
            tarifProTexte: 'Anwalt, Familienmediator, Sozialarbeiter.',
            tarifProAvantage1: 'Unbegrenzte Anzahl an Fällen',
            tarifProAvantage2: 'Lesezugriff, auf Einladung eines Elternteils',
            tarifProAvantage3: 'Authentifizierter Historienexport',
            mentionTarifs: 'Preise inkl. Steuern. Der Dienst ist noch nicht eröffnet: Die genauen Bedingungen — Testzeitraum, Kündigungsmodalitäten — werden hier bei der Eröffnung veröffentlicht.',
            surTitreMobile: 'Auf dem Smartphone',
            titreMobile: 'Der Kalender in der Tasche, die Historie am selben Ort',
            texteMobile: 'Die iOS- und Android-Apps geben Zugriff auf denselben Fall wie das Web: gleiche Rechte, gleiche Daten, gleiche Historie. Eine Benachrichtigung informiert Sie über einen Tauschvorschlag oder eine dringende Warnung — niemals darüber, ob der andere Elternteil online ist.',
            appStore: 'App Store',
            googlePlay: 'Google Play',
            mobileNote: 'Die Links zu App Store und Google Play werden mit der Eröffnung des Dienstes aktiviert.',
            mobileCalendrierAlt: 'Vorschau des Kalenderbildschirms der mobilen App.',
            mobileDossiersAlt: 'Vorschau des Startbildschirms der mobilen App: die Liste der Fälle.',
            mobileLegende: 'Vorschauen der mobilen App. Beispieldaten.',
        },
        waitlist: {
            titre: 'Bei Start benachrichtigt werden',
            texte: 'Hinterlassen Sie Ihre Adresse: Sie erhalten eine Nachricht bei der Eröffnung, und sonst nichts. Kein Newsletter, keine Erinnerung.',
            labelEmail: 'E-Mail-Adresse',
            bouton: 'Anmelden',
            aide: 'Wird nur verwendet, um Sie bei der Eröffnung zu benachrichtigen. Jederzeit löschbar.',
            erreurEmailInvalide: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
            envoiEnCours: 'Wird gesendet…',
            succes: 'Notiert. Sie erhalten eine Nachricht bei der Eröffnung.',
            echec: 'Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es in Kürze erneut.',
        },
        confidentialite: {
            titre: 'Datenschutzerklärung',
            description: 'Wie Repère personenbezogene Daten verarbeitet: Hosting in Frankreich, Verschlüsselung, keine Tracker.',
            avisProvisoire: 'Vorläufiges Dokument, ausstehende rechtliche Prüfung. Es beschreibt die technische Funktionsweise des Dienstes zutreffend, seine rechtliche Formulierung muss aber vor der Eröffnung von einem Rechtsbeistand geprüft werden (siehe Projekt-Roadmap).',
            miseAJour: (date) => `Letzte Aktualisierung: ${date}.`,
            siteTitre: 'Diese Website',
            siteTexte1: 'Die Website setzt keine Cookies und ruft keinen Drittanbieterdienst auf.',
            siteTexte2: 'Wenn Sie sich für die Warteliste anmelden, wird nur Ihre E-Mail-Adresse gespeichert, zusammen mit der Seite, von der die Anmeldung stammt. Sie dient ausschließlich dazu, Sie bei der Eröffnung zu benachrichtigen, und Sie können jederzeit ihre Löschung verlangen.',
            serviceTitre: 'Der Dienst',
            serviceHebergementTitre: 'Hosting in Frankreich',
            serviceHebergementTexte: ', einschließlich Backups. Keine Übertragung außerhalb der Europäischen Union.',
            serviceChiffrementTitre: 'Verschlüsselung',
            serviceChiffrementTexte: ': Der Austausch wird bei der Übertragung verschlüsselt; sensible Inhalte und Dokumente werden im Ruhezustand verschlüsselt, mit einem eigenen Schlüssel für jeden Ko-Elternschaftsfall.',
            serviceBoutTitre: 'Keine Ende-zu-Ende-Verschlüsselung',
            serviceBoutTexte: ', und wir sagen es klar: Der Dienst muss die Historie zeitstempeln, versiegeln und exportieren können, um sein Versprechen zu halten. Ihre Inhalte können vom Dienst entschlüsselt werden, niemals von Dritten.',
            serviceHistoriqueTitre: 'Gemeinsame Historie bleibt erhalten',
            serviceHistoriqueTexte: ': Das Löschen eines Kontos anonymisiert dessen Inhaber, zerstört aber nicht die geteilte Historie, die auch dem anderen Elternteil gehört. Dies ist ein wesentliches Merkmal des Dienstes, das bereits bei der Registrierung angegeben wird.',
            serviceSignatureTitre: 'Unabhängiger Nachweis',
            serviceSignatureTexte: ': jeder Eintrag wird im Moment seiner Erfassung von einer unabhängigen, außerhalb von Repère stehenden Stelle digital signiert — so, wie ein amtliches Dokument beglaubigt wird. Der Nachweis, dass seither nichts verändert wurde, bleibt jederzeit überprüfbar.',
            servicePubTitre: 'Keine Werbung, kein Tracker, kein Weiterverkauf.',
            servicePubTexte: ' Technische Protokolle enthalten keine personenbezogenen Daten.',
            droitsTitre: 'Ihre Rechte',
            droitsTexte: 'Zugang, Berichtigung, Übertragbarkeit, Löschung, Einschränkung und Widerspruch können beim Dienst geltend gemacht werden. Der Export des Falls dient auch als Antwort auf ein Zugangsrecht. Die Kontaktdaten des Datenschutzbeauftragten werden hier vor der Eröffnung des Dienstes veröffentlicht.',
        },
        mentionsLegales: {
            titre: 'Impressum',
            description: 'Impressum der Website Repère: Herausgeber, Hosting und geistiges Eigentum.',
            avisProvisoire: 'Vorläufiges Dokument, ausstehende rechtliche Prüfung. Die Angaben zur Identifizierung von Herausgeber und Hoster werden vor der Eröffnung des Dienstes ergänzt.',
            miseAJour: (date) => `Letzte Aktualisierung: ${date}.`,
            editeurTitre: 'Herausgeber',
            editeurTexte: 'Repère — Rechtsform, Sitz, Registernummer und Verantwortlicher für die Veröffentlichung folgen.',
            hebergementTitre: 'Hosting',
            hebergementTexte: 'Die Website und der Dienst werden in Frankreich gehostet. Keine Daten werden außerhalb der Europäischen Union übertragen.',
            contactTitre: 'Kontakt',
            contactTexte: 'Kontaktadresse folgt.',
            proprieteTitre: 'Geistiges Eigentum',
            proprieteTexte: 'Die Marke Repère, ihr Logo und der Inhalt dieser Website sind geschützt. Jede Vervielfältigung ohne Genehmigung ist untersagt.',
        },
    },
    notifications: {
        libelles: {
            message_new: { un: 'eine neue Nachricht', plusieurs: (n) => `${n} neue Nachrichten` },
            proposal_new: {
                un: 'eine neue Zustimmungsanfrage',
                plusieurs: (n) => `${n} neue Zustimmungsanfragen`,
            },
            proposal_answered: {
                un: 'eine Antwort auf eine Zustimmungsanfrage',
                plusieurs: (n) => `${n} Antworten auf Zustimmungsanfragen`,
            },
            expense_new: { un: 'eine neue Ausgabe', plusieurs: (n) => `${n} neue Ausgaben` },
            document_new: { un: 'ein neues Dokument', plusieurs: (n) => `${n} neue Dokumente` },
            calendar_event_new: {
                un: 'ein neuer Kalendereintrag',
                plusieurs: (n) => `${n} neue Kalendereinträge`,
            },
            alert_new: { un: 'eine Meldung', plusieurs: (n) => `${n} Meldungen` },
            professional_invited: {
                un: 'ein geöffneter Fachzugang',
                plusieurs: (n) => `${n} geöffnete Fachzugänge`,
            },
            writing_opened: {
                un: 'der Schreibzugriff auf eine Akte geöffnet',
                plusieurs: (n) => `der Schreibzugriff auf ${n} Akten geöffnet`,
            },
        },
        enumeration: (morceaux) => morceaux.length <= 1
            ? (morceaux[0] ?? '')
            : `${morceaux.slice(0, -1).join(', ')} und ${morceaux.at(-1)}`,
    },
    mail: {
        verification: {
            objet: 'Bestätigen Sie Ihre E-Mail-Adresse',
            texte: (lien) => [
                'Hallo,',
                '',
                'Um Ihre E-Mail-Adresse bei Repère zu bestätigen, öffnen Sie diesen Link:',
                lien,
                '',
                'Dieser Link ist 24 Stunden gültig. Falls Sie diese Anfrage nicht gestellt haben,',
                'können Sie diese Nachricht ignorieren: Es wird kein Konto aktiviert.',
                '',
                'Repère — Organisation & Gelassenheit',
            ].join('\n'),
            titre: 'Bestätigen Sie Ihre E-Mail-Adresse',
            paragraphes: [
                'Hallo,',
                'Um Ihre E-Mail-Adresse bei Repère zu bestätigen, verwenden Sie die Schaltfläche unten.',
            ],
            bouton: 'Meine Adresse bestätigen',
            note: 'Dieser Link ist 24 Stunden gültig. Falls Sie diese Anfrage nicht gestellt haben, können Sie diese Nachricht ignorieren: Es wird kein Konto aktiviert.',
        },
        invitationDossier: {
            objet: 'Sie sind eingeladen, einem Fall auf Repère beizutreten',
            texte: (inviterName, lien) => [
                'Hallo,',
                '',
                `${inviterName} nutzt Repère, um den Alltag Ihrer Kinder zu organisieren,`,
                'und lädt Sie ein, dem Fall beizutreten.',
                '',
                'Repère schützt beide Elternteile gleichermaßen: Sie erhalten genau die',
                'gleichen Rechte, und die Historie gehört keinem von beiden. Niemand kann',
                'etwas daraus entfernen oder Sie ausschließen.',
                '',
                'Um dem Fall beizutreten:',
                lien,
                '',
                'Dieser Link ist 30 Tage gültig. Wenn Sie ihn lieber nicht nutzen möchten,',
                'können Sie diese Nachricht ignorieren: Es passiert nichts.',
                '',
                'Repère — Organisation & Gelassenheit',
            ].join('\n'),
            titre: 'Sie sind eingeladen, einem Fall beizutreten',
            paragraphes: (inviterName) => [
                'Hallo,',
                `${inviterName} nutzt Repère, um den Alltag Ihrer Kinder zu organisieren, und lädt Sie ein, dem Fall beizutreten.`,
                'Repère schützt beide Elternteile gleichermaßen: Sie erhalten genau die gleichen Rechte, und die Historie gehört keinem von beiden. Niemand kann etwas daraus entfernen oder Sie ausschließen.',
            ],
            bouton: 'Dem Fall beitreten',
            note: 'Dieser Link ist 30 Tage gültig. Wenn Sie ihn lieber nicht nutzen möchten, können Sie diese Nachricht ignorieren: Es passiert nichts.',
        },
        digest: {
            objet: 'Neuigkeiten in Ihrem Repère-Fall',
            texte: (resume, webUrl) => [
                'Hallo,',
                '',
                `Ihr Repère-Fall enthält ${resume}.`,
                '',
                'Zum Ansehen:',
                webUrl,
                '',
                'Sie können Ihre stillen Stunden und die Häufigkeit dieser Nachrichten',
                'in den Kontoeinstellungen anpassen.',
                '',
                'Repère — Organisation & Gelassenheit',
            ].join('\n'),
            titre: 'Neuigkeiten in Ihrem Fall',
            paragraphes: (resume) => ['Hallo,', `Ihr Repère-Fall enthält ${resume}.`],
            bouton: 'Meinen Fall öffnen',
            note: 'Sie können Ihre stillen Stunden und die Häufigkeit dieser Nachrichten in den Kontoeinstellungen anpassen.',
        },
        alerte: {
            objetUrgent: 'Dringende Warnung zu Ihrem Repère-Fall',
            objetNormal: 'Warnung zu Ihrem Repère-Fall',
            texte: (motif, webUrl) => [
                'Hallo,',
                '',
                `In Ihrem Repère-Fall wurde eine Warnung mit dem Grund „${motif}" hinterlegt.`,
                '',
                'Zum Lesen:',
                webUrl,
                '',
                'Repère — Organisation & Gelassenheit',
            ].join('\n'),
            titreUrgent: 'Dringende Warnung zu Ihrem Fall',
            titreNormal: 'Warnung zu Ihrem Fall',
            paragraphes: ['Hallo,', 'In Ihrem Repère-Fall wurde eine Warnung hinterlegt.'],
            encart: (motif) => `Angegebener Grund: „${motif}"`,
            bouton: 'Warnung lesen',
        },
        invitationPro: {
            objet: 'Ihnen wurde ein professioneller Zugang bei Repère eröffnet',
            texte: (modules, url) => [
                'Hallo,',
                '',
                'Ein Elternteil hat Ihnen einen Lesezugang zu seinem Repère-Fall eröffnet.',
                '',
                `Sie sehen: ${modules}.`,
                '',
                'Dieser Zugang ist rein lesend: Sie schreiben nichts, und nichts, was Sie',
                'einsehen, wird durch Ihren Besuch verändert. Ihre Zugriffe werden im',
                'Register des Falls vermerkt, das beide Elternteile lesen können.',
                'Jeder der beiden Elternteile kann ihn jederzeit beenden.',
                '',
                'Er ist kostenlos und unverbindlich. Sie finden ihn hier:',
                url,
                '',
                'Repère — Organisation & Gelassenheit',
            ].join('\n'),
            titre: 'Ihnen wurde ein professioneller Zugang eröffnet',
            paragraphes: (modules) => [
                'Hallo,',
                'Ein Elternteil hat Ihnen einen Lesezugang zu seinem Repère-Fall eröffnet.',
                `Sie sehen: ${modules}.`,
                'Dieser Zugang ist rein lesend: Sie schreiben nichts, und nichts, was Sie einsehen, wird durch Ihren Besuch verändert. Ihre Zugriffe werden im Register des Falls vermerkt, das beide Elternteile lesen können. Jeder der beiden Elternteile kann ihn jederzeit beenden.',
                'Er ist kostenlos und unverbindlich.',
            ],
            bouton: 'Meinen Zugang öffnen',
        },
        lienPaiement: {
            objet: 'Ihr Link zum Abonnement von Repère',
            texte: (lien) => [
                'Guten Tag,',
                '',
                'Sie haben soeben in der Repère-App ein Abonnement angefragt.',
                'Öffnen Sie diesen Link, um es abzuschließen — auf diesem oder einem anderen Gerät:',
                lien,
                '',
                'Dieser Link ist 1 Stunde gültig. Danach fordern Sie ihn erneut in der App an.',
                'Es wird nichts abgebucht, solange Sie nicht bestätigt haben.',
                '',
                '— Repère',
            ].join('\n'),
            titre: 'Abonnement abschließen',
            paragraphes: [
                'Sie haben soeben in der App ein Abonnement angefragt. Die Zahlung wird hier abgeschlossen — auf diesem oder einem anderen Gerät.',
                'Es wird nichts abgebucht, solange Sie nicht bestätigt haben.',
            ],
            bouton: 'Zahlung abschließen',
            note: 'Dieser Link ist 1 Stunde gültig. Danach fordern Sie ihn erneut in der App an.',
        },
        reinitialisation: {
            objet: 'Zurücksetzen Ihres Passworts',
            texte: (lien) => [
                'Hallo,',
                '',
                'Sie haben eine Zurücksetzung Ihres Repère-Passworts angefordert. Öffnen Sie diesen Link:',
                lien,
                '',
                'Dieser Link ist 1 Stunde gültig und funktioniert nur einmal.',
                'Falls Sie diese Anfrage nicht gestellt haben, ignorieren Sie diese Nachricht:',
                'Ihr aktuelles Passwort bleibt gültig.',
                '',
                'Repère — Organisation & Gelassenheit',
            ].join('\n'),
            titre: 'Zurücksetzen Ihres Passworts',
            paragraphes: ['Hallo,', 'Sie haben eine Zurücksetzung Ihres Repère-Passworts angefordert.'],
            bouton: 'Mein Passwort zurücksetzen',
            note: 'Dieser Link ist 1 Stunde gültig und funktioniert nur einmal. Falls Sie diese Anfrage nicht gestellt haben, ignorieren Sie diese Nachricht: Ihr aktuelles Passwort bleibt gültig.',
        },
        suppressionDossier: {
            objet: 'Eine Aktenlöschung wartet auf Ihre Bestätigung',
            texte: (demandeur, lien) => [
                'Guten Tag,',
                '',
                demandeur
                    ? `${demandeur} hat die Löschung einer Repère-Akte beantragt, die Sie teilen.`
                    : 'Sie haben die Löschung einer Ihrer Repère-Akten beantragt.',
                '',
                'Bisher wurde nichts gelöscht. Die Löschung wird über diesen Link bestätigt:',
                lien,
                '',
                'Nach der Bestätigung bleibt die Akte dreißig Tage lesbar, ohne bearbeitet werden',
                'zu können, danach wird sie endgültig zerstört. In dieser Zeit kann die Löschung',
                'jederzeit abgebrochen werden, von jedem von beiden.',
                '',
                'Dieser Link ist 7 Tage gültig. Ohne Antwort verfällt der Antrag von selbst und',
                'die Akte bleibt unversehrt.',
                '',
                'Repère — Organisation & Gelassenheit',
            ].join('\n'),
            titre: 'Eine Aktenlöschung wartet auf Ihre Bestätigung',
            paragraphes: (demandeur) => [
                'Guten Tag,',
                demandeur
                    ? `${demandeur} hat die Löschung einer Repère-Akte beantragt, die Sie teilen.`
                    : 'Sie haben die Löschung einer Ihrer Repère-Akten beantragt.',
                'Bisher wurde nichts gelöscht. Nach der Bestätigung bleibt die Akte dreißig Tage lesbar, ohne bearbeitet werden zu können, danach wird sie endgültig zerstört. In dieser Zeit kann die Löschung jederzeit abgebrochen werden, von jedem von beiden.',
            ],
            bouton: 'Antrag öffnen',
            note: 'Dieser Link ist 7 Tage gültig. Ohne Antwort verfällt der Antrag von selbst und die Akte bleibt unversehrt.',
        },
    },
    mobile: {
        notifications: {
            verification: 'Benachrichtigungen: wird geprüft…',
            pretes: 'Benachrichtigungen auf diesem Gerät bereit.',
            refusees: 'Sie haben Benachrichtigungen abgelehnt. Sie können sie in den Telefoneinstellungen wieder aktivieren.',
            indisponiblesTitre: 'Benachrichtigungen nicht verfügbar',
            appareilRattacheTitre: 'Gerät registriert',
            appareilActif: 'Dieses Gerät ist registriert. Sie werden auch bei geschlossener App benachrichtigt.',
            appareilInactif: 'Sie sind angemeldet, aber dieses Gerät kann noch nicht benachrichtigt werden.',
        },
        dossiers: {
            titre: 'Ihre Akten',
            chargement: 'Wird geladen…',
            erreur: 'Ihre Akten konnten nicht geladen werden.',
            aucun: 'Noch keine Akte. Sie können eine in der Web-App anlegen.',
            deconnexion: 'Abmelden',
            ouvrirIndice: 'Öffnet den Kalender dieser Akte',
        },
        calendrier: {
            retour: 'Zurück',
            aujourdHui: 'Heute',
            jusqua: (heure) => `Bis ${heure}`,
        },
    },
};
//# sourceMappingURL=de.js.map